import { render, staticRenderFns } from "./chemMsds.vue?vue&type=template&id=accec456"
import script from "./chemMsds.vue?vue&type=script&lang=js"
export * from "./chemMsds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('accec456')) {
      api.createRecord('accec456', component.options)
    } else {
      api.reload('accec456', component.options)
    }
    module.hot.accept("./chemMsds.vue?vue&type=template&id=accec456", function () {
      api.rerender('accec456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemMsds.vue"
export default component.exports